import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid as Grid,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
  styled
} from "@mui/material";
import BuildIdLogo from "../../assets/images/build_id_logo.png";
import { BIBlue, BIGrey } from "../../assets/helpers";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_NEAREST_SITE_DETAILS,
  SAVE_ONBOARDING_USER_EXPERIENCE
} from "../../constant/Apipath";
import { setShowmapmodal } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Close } from "@mui/icons-material";
import { useCallback } from "react";
import { useMemo } from "react";

export const ExperiencePage = (props) => {
  const { companyId, gotoFinishPage, openExperiencePage, loadingPage, searchTerm } = props;

  const [nearestSiteInfo, setNearestSiteInfo] = useState([]);
  const { selectedSite } = useSelector((state) => state?.main);
  const [selectedUserSite, setSelectedUserSite] = useState({});
  const dispatch = useDispatch();
  const loginData = useSelector((state) => state.main?.loginData);

  const { UserId, accessToken } = useMemo(() => {
    return {
      UserId: loginData?.userInformation?.UserId,
      accessToken: loginData?.accessToken
    };
  }, [loginData]);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 5,
    width: "100%",
    [`& .MuiLinearProgress-bar`]: {
      borderRadius: 5,
      backgroundColor: BIBlue
    }
  }));

  const handleSelectSite = () => {
    let mapModal = {
      open: true,
      from: "Create Account",
      select: ""
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const fetchNearestSiteList = useCallback(async () => {
    try {
      const obj = {
        UserId: Number(UserId),
        UserLatitude: searchTerm?.latitude || 51.04483,
        UserLongitude: searchTerm?.longitude || -114.071518,
        PageNumber: 1,
        NrRowsPerPage: 5
      };
      const res = await Postrequestcall(FETCH_NEAREST_SITE_DETAILS, obj, accessToken);
      setNearestSiteInfo(res?.data?.data);
    } catch (error) {
      console.log("fetchNearestSiteList-> Error When Fetching Nearest Site Details: ", error);
    }
  }, [UserId, accessToken, searchTerm?.latitude, searchTerm?.longitude]);

  const handleSiteClick = (site) => {
    setSelectedUserSite(site);
  };

  const handleExperienceNext = async () => {
    loadingPage();
    try {
      const obj = {
        UserId: Number(UserId),
        SiteId: selectedUserSite?.id || 0,
        CompanyId: companyId || 0
      };
      await Postrequestcall(SAVE_ONBOARDING_USER_EXPERIENCE, obj, accessToken);
      gotoFinishPage();
    } catch (error) {
      openExperiencePage();
      console.log("handleExperienceNext-> Error When Saving Onboarding User Experience: ", error);
    }
  };

  const handleExperienceSkip = () => {
    gotoFinishPage();
  };

  useEffect(() => {
    fetchNearestSiteList();
  }, [fetchNearestSiteList]);

  useEffect(() => {
    if (selectedSite && Object.keys(selectedSite).length > 0) {
      setSelectedUserSite(selectedSite);
    }
  }, [selectedSite]);

  return (
    <Box sx={{ p: 4 }}>
      <Grid container direction="column" alignItems={"center"} spacing={2}>
        {/* Logo */}
        <Grid item>
          <img src={BuildIdLogo} alt="" style={{ display: "block", margin: "0 auto" }} />
        </Grid>

        <Grid item justifyContent={"center"} width={"80%"}>
          <BorderLinearProgress variant="determinate" value={100} />
          <Grid item size={{ xs:6 }} display={"flex"} justifyContent={"space-between"}>
            <Typography variant="caption" sx={{ textAlign: "left" }}>
              Experience
            </Typography>
            <Typography variant="caption" sx={{ textAlign: "right" }}>
              3/3
            </Typography>
          </Grid>
        </Grid>

        {/* Title */}
        <Grid item align="center" sx={{ width: "80%" }}>
          <Typography variant="h5">What site are you currently working on?</Typography>
        </Grid>

        <Grid item align="center" sx={{ width: "80%" }}>
          {Object.keys(selectedUserSite).length > 0 ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              sx={{
                border: "1px solid grey",
                borderRadius: "10px",
                padding: "12px",
                width: "80%" // Ensure Stack takes full width
              }}>
              <Stack spacing={0.5}>
                <Typography variant="h6">{selectedUserSite?.name}</Typography>
                <Typography variant="body2">
                  {selectedUserSite?.address ||
                    `${selectedUserSite?.latitude}, ${selectedUserSite?.longitude}`}
                </Typography>
              </Stack>
              <IconButton onClick={() => setSelectedUserSite({})}>
                <Close />
              </IconButton>
            </Stack>
          ) : (
            <Button variant="contained" fullWidth onClick={handleSelectSite}>
              SELECT A SITE
            </Button>
          )}
        </Grid>

        {Object.keys(selectedUserSite).length > 0 ? (
          <Grid item align="center" sx={{ width: "80%" }}>
            <Typography
              variant="body2"
              style={{ color: BIBlue, cursor: "pointer" }}
              onClick={handleSelectSite}>
              Select a different Site
            </Typography>
          </Grid>
        ) : (
          <Grid item sx={{ width: "80%" }}>
            <Typography variant="body2" color={BIGrey}>
              Suggested from your location
            </Typography>
            {nearestSiteInfo?.map((site, index) => (
              <Typography
                key={index}
                onClick={() => handleSiteClick(site)}
                variant="body2"
                style={{ color: BIBlue, cursor: "pointer" }}>
                {site.name} ({site.address})
              </Typography>
            ))}
          </Grid>
        )}

        <Grid item align="center" sx={{ marginTop: "15%" }}>
          <Button sx={{ color: BIBlue }} onClick={handleExperienceSkip}>
            SKIP
          </Button>
        </Grid>

        <Grid item align="center" sx={{ width: "80%" }}>
          <Button
            variant="contained"
            fullWidth
            disabled={Object.keys(selectedUserSite).length === 0}
            onClick={handleExperienceNext}>
            NEXT
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
